import React, { useState, useEffect } from 'react'
import { Outlet, useLocation, useLoaderData } from "react-router-dom";
import { PageLoader } from './PageLoader';
import { NotFound } from './ErrorPages';
import { useParams } from 'react-router-dom';
import { VendorModel } from '../models/Vendor';
import { titlize } from '../helperFunctions';
import { useDispatch } from 'react-redux';
import { customerSearchBoxLabel, customerSearchBoxNote, displayName,merchantLogo,minimumAcceptAmountForPayment, searchboxPlaceholderLabel} from '../redux/actions';
import CustomerPage from '../components/CustomerPage';

const CheckVendor = () => {

    const location = useLocation();
    const { vendor_name } = useParams();

    const dispatch = useDispatch();

    const [loader, setLoader] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const data = useLoaderData()

    const callVendorAPI = async () => {
        setLoader(true);
        try {
            const response = data
            if (response.success) {
                document.title = titlize(vendor_name);
                setLoader(false);
                setSuccess(true);
                setError(false);
                dispatch(displayName(response?.data?.display_name));
                dispatch(customerSearchBoxLabel(response?.data?.customer_search_box_label));
                dispatch(customerSearchBoxNote(response?.data?.customer_search_box_note));
                dispatch(merchantLogo(response?.data?.merchant_logo));
                dispatch(minimumAcceptAmountForPayment(response?.data?.minimum_accept_amount_for_payment));
                dispatch(searchboxPlaceholderLabel(response?.data?.search_box_placeholder_label))
            } else {
                setLoader(false);
                setSuccess(false);
                setError(true);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            return <NotFound />;
        }
    };

    useEffect(() => {
        if (data) {
            callVendorAPI()
        }
    }, [vendor_name])
    if (loader) {
        return <PageLoader />
    }

    if (!loader && success) {
        return <CustomerPage />
    }

    if (!loader && error) {
        return <NotFound />;
    }
}

export { CheckVendor };